import React from 'react'
import PropTypes from 'prop-types'

const dateList = {
  preAppt: [
    {
      styles: 'hour1',
      label: '1 hour',
      key: 1,
    },
    {
      styles: 'hour7',
      label: '7 hours',
      key: 2,
    },
    {
      styles: 'day1',
      label: '1 day',
      key: 3,
    },
    {
      styles: 'day15',
      label: '15 days',
      key: 4,
    },
    {
      styles: 'day30',
      label: '30 days',
      key: 5,
    },
  ],
  postAppt: [
    {
      styles: 'day30',
      label: '30 days',
      key: 1,
    },
    {
      styles: 'day15',
      label: '15 days',
      key: 2,
    },
    {
      styles: 'day1',
      label: '1 day',
      key: 3,
    },
    {
      styles: 'hour7',
      label: '7 hours',
      key: 4,
    },
    {
      styles: 'hour1',
      label: '1 hour',
      key: 5,
    },
  ],
  weeksAppt: [
  ],
}

const setDates = (isPostAppt, isWeeks) => {
  if (isWeeks) {
    return dateList.weeksAppt
  }

  return isPostAppt ? dateList.preAppt : dateList.postAppt
}

const SliderScale = ({ styles, isPostAppt, isWeeks }) => (
  <div style={styles.scaleContainer} className="slider-scaleContainer">
    {setDates(isPostAppt, isWeeks).map(date => (
      <div style={styles[date.styles]} key={date.key}>
        {date.label}
      </div>
    ))}
  </div>
)

SliderScale.propTypes = {
  styles: PropTypes.objectOf(PropTypes.any),
  isPostAppt: PropTypes.bool,
  isWeeks: PropTypes.bool,
}

export default SliderScale



// WEBPACK FOOTER //
// ./src/components/Settings/CreateSlider/SliderScale.js